import axios from "axios";
import { PROVIDER_BOOKINGS,CHECK_IN_SCAN, CHECK_IN_SCAN_PARTICIPANTS } from "../../../../config";

export function searchByBookingRef(searchValue) {
	return axios.get(
		(PROVIDER_BOOKINGS) + '?q='+ searchValue,
	);
}

export function getBookingDetails(bookingObj) {
    return axios.post(CHECK_IN_SCAN,bookingObj);
}

export function checkInParticipants(checkInParticipants) {
    return axios.post(CHECK_IN_SCAN_PARTICIPANTS,checkInParticipants);
}